export default __webpack_public_path__ + "306112bb52d2ef4ce22c2633e6291e86.png";